import { SchoolBankConfigType } from "../../types/Finance";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { get, post, put } from "../../utils/axios-config";
import { SCHOOL_BANK_CONFIGS } from "../../utils/constants";

export const createSchoolBankConfig = async (data: SchoolBankConfigType) => await post<SchoolBankConfigType, string>(SCHOOL_BANK_CONFIGS, data);
export const updateSchoolBankConfig = async (data: SchoolBankConfigType) => await put<SchoolBankConfigType, string>(SCHOOL_BANK_CONFIGS, data);

export const getSchoolBankConfig = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });

    const url = `${SCHOOL_BANK_CONFIGS}?${queryParams.toString()}`;
    return await get<PagedResultsType<SchoolBankConfigType>>(url)
};